import React from 'react'

function Footer() {
  return (
    <footer className='w-100' style={{backgroundColor: '#a6191f'}}>
        <div className=' w-100  p-3'>
            <p className='text-light m-0'>
              For Admission enquiries email us at <a className="text-light" href="mailto:registrargadvasu@gmail.com">registrar@gadvasu.in</a> or contact at <a href='tel:0161-2553394' className="text-light" >0161-2553394</a>  (during working hours). 
            </p>
           
            <p className='text-light m-0'>
              For Technical Assistance email us at <a className="text-light" href="mailto:support2@eshiksa.com">support2@eshiksa.com</a> or contact at  <a href='tel:7413048222' className="text-light" >7413048222</a> or   <a href='tel:7413959555' className="text-light" >7413969555</a>
            </p>
            <p className='text-light m-0'>
              Note: Files to be uploaded for Photograph,Signature,Thumb Impression and Academic certificate need to be of .jpeg/.png/.jpg format only with a maximum size of 1mb each.
            </p>
        </div>
    </footer>
  )
}

export default Footer;